import { render, staticRenderFns } from "./HomeProjects.vue?vue&type=template&id=0c8ba977&scoped=true&"
import script from "./HomeProjects.vue?vue&type=script&lang=js&"
export * from "./HomeProjects.vue?vue&type=script&lang=js&"
import style0 from "./HomeProjects.vue?vue&type=style&index=0&id=0c8ba977&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8ba977",
  null
  
)

export default component.exports